import { useState } from "react";
import { CheckCircleIcon } from "@phosphor-icons/react/CheckCircle";
import { Icon } from "../../Icons/Icon";
import type { SavedColumnConfiguration } from "./columnConfigurations";

export function NameInputForm_({
  placeholder,
  submitLabel,
  onSubmit,
  onCancel,
}: {
  placeholder: string;
  submitLabel: string;
  onSubmit: (name: string) => void;
  onCancel: () => void;
}) {
  const [name, setName] = useState("");

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (name.trim()) onSubmit(name.trim());
      }}
      className="flex flex-col gap-2"
    >
      <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder={placeholder}
        autoFocus
        className="w-full rounded-md border-2 border-border bg-card px-2.5 py-1.5 text-sm text-foreground outline-none focus:border-foreground/40"
      />
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="flex-1 rounded-md px-2 py-1.5 text-xs font-medium text-content transition-colors hover:bg-muted"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={!name.trim()}
          className="flex-1 rounded-md bg-foreground px-2 py-1.5 text-xs font-bold text-background transition-colors hover:bg-foreground/80 disabled:opacity-40"
        >
          {submitLabel}
        </button>
      </div>
    </form>
  );
}

export function ConfigurationItem_({
  configuration,
  isActive,
  onLoad,
}: {
  configuration: SavedColumnConfiguration;
  isActive: boolean;
  onLoad: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onLoad}
      className="flex w-full items-center gap-1.5 py-1.5 text-left text-sm font-medium text-content-secondary transition-colors hover:text-content"
    >
      <span className={`flex-1 ${isActive ? "font-bold text-foreground" : ""}`}>
        {configuration.configName}
      </span>
      {isActive && (
        <Icon icon={CheckCircleIcon} size="sm" color="text-dark-green" />
      )}
    </button>
  );
}
